const universities = [
  { id: "sjsu", name: "San Jose State University" },
  { id: "chico", name: "Chico State University" },
  { id: "berkeley", name: "UC Berkeley" },
  { id: "santacruz", name: "UC Santa Cruz" },
  
  // Add more universities here as needed
];


export default universities;
